import { immerOn } from 'ngrx-immer/store';
import { INITIAL_ROOM_COUNT_RANGE } from './room-count.state';
import {
  resetRoomCountFilter,
  setRoomCountFilter,
  setRoomCountFilterBasedOnUrlValues,
} from './room-count.actions';
import { resetAllFilters } from '../filter.actions';
import {
  FilterState,
  RoomCountFilterState,
  RoomCountRange,
} from '@immosky/types';

export const initialRoomCountState: RoomCountFilterState = {
  isActive: false,
  isDisplayed: false,
  options: [],
  filter: INITIAL_ROOM_COUNT_RANGE,
  default: INITIAL_ROOM_COUNT_RANGE,
};

export const roomCountReducers = [
  immerOn(setRoomCountFilter, (state: FilterState, { filter }) => {
    updateRoomCountFilter(state, filter);
  }),
  immerOn(resetRoomCountFilter, resetAllFilters, (state: FilterState) => {
    updateRoomCountFilter(state, state.roomCount.default);
  }),
  immerOn(
    setRoomCountFilterBasedOnUrlValues,
    (state: FilterState, { values }) => {
      const options = state.roomCount.options;
      const minOption = options.find((o) => o.value === values.min);
      const maxOption = options.find((o) => o.value === values.max);

      if (minOption) {
        state.roomCount.filter.min = minOption;
      }

      if (maxOption) {
        state.roomCount.filter.max = maxOption;
      }

      state.roomCount.isActive = isRoomCountFilterActive(
        state.roomCount.filter,
        state.roomCount.default
      );
    }
  ),
];

export function updateRoomCountFilter(
  state: FilterState,
  filter: RoomCountRange
) {
  state.roomCount.filter = filter;
  state.roomCount.isActive = isRoomCountFilterActive(
    state.roomCount.filter,
    state.roomCount.default
  );
}

export function isRoomCountFilterActive(
  filter: RoomCountRange,
  defaultFilter: RoomCountRange
): boolean {
  const isMinLivingSpaceDefault = filter.min.value === defaultFilter.min.value;
  const isMaxLivingSpaceDefault = filter.max.value === defaultFilter.max.value;
  return !(isMinLivingSpaceDefault && isMaxLivingSpaceDefault);
}
